import { createApi } from "@reduxjs/toolkit/query/react";
import api from "../services/api";

// Axios keeps the existing cookie-based authentication and error handling.
// The RTK Query cache is scoped to the in-memory Redux store.
const axiosBaseQuery = async ({ url, params }, { signal }) => {
  try {
    const response = await api.get(url, { params, signal });
    return { data: response.data };
  } catch (error) {
    return {
      error: {
        status: error.response?.status || "FETCH_ERROR",
        data: error.response?.data || error.message,
      },
    };
  }
};

export const adminApi = createApi({
  reducerPath: "adminApi",
  baseQuery: axiosBaseQuery,
  tagTypes: ["Admins", "Permissions", "JishoWords", "Paragraphs"],
  keepUnusedDataFor: 90,
  refetchOnMountOrArgChange: 60,
  endpoints: (builder) => ({
    getAdmins: builder.query({
      query: (params) => ({ url: "/admins/search", params }),
      providesTags: ["Admins"],
    }),
    getPermissions: builder.query({
      query: (params) => ({ url: "/permissions/search", params }),
      providesTags: ["Permissions"],
    }),
    getJishoWords: builder.query({
      query: (params) => ({ url: "/jishoWords/search", params }),
      providesTags: ["JishoWords"],
    }),
    getParagraphs: builder.query({
      query: (params) => ({ url: "/paragraphs/search", params }),
      providesTags: ["Paragraphs"],
    }),
  }),
});

export const {
  useGetAdminsQuery,
  useGetPermissionsQuery,
  useGetJishoWordsQuery,
  useGetParagraphsQuery,
} = adminApi;
